import React, { FC, ReactNode, useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import classNames from 'classnames';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';

import getClassName from 'src/common/utils/getClassName';
import decorateComponent from 'src/common/utils/decorateComponent';
import { TITLE } from '../../../common/constants';
import Layout from '../../../common/components/Layout';
import Header from '../../../common/components/Header';
import { setLoadingComplete } from '../../../common/ducks/loading';

import s from './Inquiry.module.scss';

const mapDispatchToProps = {
  finishLoading: setLoadingComplete,
};

type InquiryRootProps = {
  children: ReactNode;
  finishLoading: () => void;
};

const InquiryRoot: FC<InquiryRootProps> = ({
  finishLoading,
  children,
}) => {
  const { isExact } = useRouteMatch();
  useEffect(() => {
    finishLoading();
  }, [finishLoading]);

  const classNameModifier = classNames(
    'modal with-blue-gradient-background',
    {
      welcome: isExact,
    },
  );

  return (
    <Layout classNameModifier={classNameModifier}>
      <Header
        withNav={false}
        withSearchBar={false}
        classNameModifier={classNameModifier}
      />
      <div className={getClassName(s, 'modal', classNameModifier)}>
        <Helmet
          defaultTitle={`${TITLE.INQUIRY} | ${TITLE.PROJECT}`}
          titleTemplate={`${TITLE.INQUIRY}: %s | ${TITLE.PROJECT}`}
        />
        {children}
      </div>
    </Layout>
  );
};

const decorators = [
  connect(null, mapDispatchToProps),
];

export default decorateComponent(InquiryRoot, decorators);
